import Vue from  'vue'

import mixin from '../../core/core-video-player'
import CoreDragArea from '../../core/core-drag-area'

export default {

    mixins: [mixin],

    /*props: {

        autoplay: { type: Boolean, default: true }
    },*/

    data()
    {
        return {

            // Fix Android click but iOS can't use other events
            disableEvents: !this.$root.$children[0].support.ios,
            seekbarW: 0

            // Fix mobile don't start
            // isPlaying: true
        }
    },

    props: {

        src: { type: String, default: null }
    },

    created()
    {
    },

    mounted()
    {
        this.eventHub.$on('window:resized', this._onResize)

        this._seekbar = this.$el.querySelector('.js-seekbar')
        this.seekbarW = this._seekbar.offsetWidth
    },

    methods: {

        close()
        {
            this.$emit('close')
        },

        _onResize()
        {
            this.seekbarW = this._seekbar.offsetWidth
        }

        /*onPlayerReady( coreVideoPlayer )
        {
            console.log( 'corevideoplayer', coreVideoPlayer )
            this.player = coreVideoPlayer
        },

        log( ...data )
        {
            console.log(...data)
        }*/
    }
}
